
const mappings = [
    { id: 'riskType', title: 'Risk Type' },
    { id: 'qualifier', title: 'Qualifier' },
    { id: 'bucket', title: 'Bucket' },
    { id: 'labelOne', title: 'Label 1' },
    { id: 'labelTwo', title: 'Label 2' },
    { id: 'amount', title: 'Amount' },
    { id: 'amountCcy', title: 'Amount CCY' },
    { id: 'amountUsd', title: 'Amount (USD)' },
    { id: 'prodClass', title: 'Prod Class' },
    { id: 'tradeId', title: 'Trade ID' },
    { id: 'imModel', title: 'IM Model' },
    { id: 'valuationDate', title: 'Valuation Date' }
];

export default mappings;
